import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { PropertyService } from 'src/app/_services/property.service';

@Component({
  selector: 'app-addproperty',
  templateUrl: './addproperty.component.html',
  styleUrls: ['./addproperty.component.css']
})
export class AddpropertyComponent implements OnInit {
  submitted=false;
  definitionForm:FormGroup;
  @Input() hammadde:any;
  constructor( 
    private propertyService:PropertyService,
    private formBuilder:FormBuilder,
    private activeModal:NgbActiveModal,
    private toastr: ToastrService
  ) { }

  ngOnInit() {

    this.definitionForm=this.formBuilder.group({
      'name':['',Validators.required],
      'englishName':['',Validators.required],

    });

    if(this.hammadde){
      this.definitionForm.get("name").patchValue(this.hammadde.name);
      this.definitionForm.get("englishName").patchValue(this.hammadde.englishName);

    }
  }



  
  close(){
    this.activeModal.close();
  }


  save(){
    if(!this.definitionForm.valid){
      this.definitionForm.markAllAsTouched();
     
      return;
    }
    this.submitted=true;


    var model={
      name:this.definitionForm.get("name").value,
      englishName:this.definitionForm.get("englishName").value,
      
    }

    if(this.hammadde){
      //update
      const updatedModel = { ...model, id: this.hammadde.id };
      this.propertyService.editHammadde(updatedModel,this.hammadde.id).subscribe(res=>{
        this.submitted=false;
        this.toastr.clear();
        this.toastr.success('', 'Kayıt güncelleme başarılı');
        this.definitionForm.reset();
    
      },err=>{
        this.toastr.error('', 'Kayıt güncelleme sırasında hata oluştu');
        this.submitted=false;
      });
    }
    else{
      //insert
      this.propertyService.addHammadde(model).subscribe(res=>{
        this.submitted=false;
        this.toastr.clear();
        this.toastr.success('', 'Kayıt başarılı');
        this.definitionForm.reset();
     
      },err=>{
        this.toastr.error('', 'Kayıt sırasında hata oluştu');
        this.submitted=false;
      });
    }
  
  }


}
